exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".range-status[data-v-3552efed]{border-radius:.5rem;border:1px solid #000;text-align:center;min-height:3rem;min-width:6rem;line-height:3rem;margin:10px 0;display:inline-block;word-wrap:break-word;width:100%}.question h2[data-v-3552efed],.question p[data-v-3552efed]{line-height:3rem;margin:10px 0}.green[data-v-3552efed]{border-color:green}.red[data-v-3552efed]{border-color:red}.yellow[data-v-3552efed]{border-color:#abab0e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3552efed","scoped":true,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/tests/Question.vue
// module id = dGSa
// module chunks = 0 1